import { StorageCache } from './StorageCache.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const Cache = new StorageCache();

export { Cache };
//# sourceMappingURL=index.mjs.map
